import styled, { css, keyframes } from "styled-components";
import { appearFromLeft } from "../../../../components/AnimatedFormContainer/styles";
import { Button, Input, Modal as M } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { enterFromBottom, enterLeft } from "./Checkout/styles";

export const Container = styled.div`
  margin: 24px auto;
  margin-top: calc(72px + 24px);
  max-width: calc(1260px + 48px);
  padding: 0 24px;
  animation: ${appearFromLeft} 1s;
  padding-bottom: 50px;

  ${({ summary }) =>
    summary &&
    css`
      max-width: 880px;
    `}
`;

export const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  width: 100%;
`;

export const Title = styled.p`
  font-family: "Open sans", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #020618;
  margin-bottom: 0;
`;

export const SearchInput = styled(Input)`
  border-radius: 8px;
  height: 40px;

  .ant-input-prefix {
    margin-right: 8px;
  }

  svg {
    width: 14px !important;
  }
`;

export const SubHeader = styled.div`
  margin-bottom: 24px;
`;

export const SubHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FilterButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  max-width: 840px;
  overflow-x: auto;
`;

export const ProductType = styled.p`
  margin-bottom: 8px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
`;

export const FilterButton = styled(Button)`
  border-radius: 8px;
  border-color: #cad5e2;
  color: #314158;
  padding: 16px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  cursor: pointer;
  transition: all 300ms ease-in-out;

  &:focus {
    color: #314158;
    background: transparent;
    border-color: #cad5e2;
  }

  &:hover {
    color: #ffffff;
    background: rgb(0, 44, 89);
    border-color: rgb(0, 44, 89);
  }

  ${({ selected }) =>
    selected &&
    css`
      font-weight: 700;

      &,
      &:hover,
      &:focus {
        color: #ffffff;
        background: #002244;
        border-color: #002244;
      }
    `}
`;

export const RedirectContractProducts = styled(Link)`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16;
  line-height: 150%;
  letter-spacing: 0px;
  color: #002244;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  svg {
    transition: all 300ms ease-in-out;
  }

  &:hover {
    color: #002244;
    text-decoration: underline;
    svg {
      transform: translateX(5px);
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  gap: 73px;
`;

export const CheckoutPreview = styled.div`
  width: 324px;
  height: 567px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  animation: ${enterFromBottom} 1s;
`;

export const CheckoutItemsContainer = styled.div`
  flex-direction: column;
  display: flex;
  gap: 16px;
  overflow-y: auto;
  max-height: calc(54px * 5 + 16px * 3.5);
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CheckoutButton = styled(Button)`
  border-radius: 8px;
  height: 40px;
  box-shadow: 0px 1px 2px 0px #19191c0a;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 300ms ease-in-out;

  color: #fff;
  background-color: #068ec3;
  border-color: #068ec3;

  &:hover,
  &:focus {
    color: #fff;
    background-color: rgb(4, 119, 165);
    border-color: rgb(4, 119, 165);
  }

  &:disabled,
  &:disabled:hover {
    background-color: #e2e8f0;
    border-color: #e2e8f0;
    color: #fff;
  }

  width: ${({ width }) => width ?? "100%"};
`;

export const CancelCheckoutButton = styled(CheckoutButton)`
  margin-top: 12px;
  color: rgb(172, 32, 32);
  background-color: #fff;
  border-color: rgb(172, 32, 32);

  &:hover,
  &:focus {
    color: rgb(172, 32, 32);
    background-color: rgb(253, 242, 242);
    border-color: rgb(172, 32, 32);
  }

  &:disabled,
  &:disabled:hover {
    background-color: #fff;
    border-color: #e2e8f0;
    color: #e2e8f0;
  }
`;

export const appear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const CheckoutEmpty = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1;
  gap: 8px;
  animation: ${appear} 300ms forwards;

  div {
    width: 248px;
  }

  p,
  span {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 105%;
    letter-spacing: 0%;
    text-align: center;
    display: block;
  }

  p {
    margin-bottom: 0;
    font-weight: 600;
  }
`;

export const ProductTableContainer = styled.div`
  flex: 1;
  position: relative;
  max-height: 567px;
  overflow-y: auto;
  /* &::-webkit-scrollbar {
    display: none;
  } */

  animation: ${enterLeft} 1s;
`;

export const ProductTableGrid = styled.div`
  display: grid;
  grid-template-columns:
    minmax(280px, 328px) minmax(130px, 178.33px) minmax(130px, 178.33px)
    minmax(130px, 178.33px);

  ${({ header }) =>
    header &&
    css`
      background: white;
      position: sticky;
      top: 0;
      z-index: 40;
    `}
`;

export const ProductColumnHeader = styled.div`
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #020618;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;

  ${({ first }) =>
    first &&
    css`
      justify-content: flex-start;
    `}
`;

export const ProductTableRow = styled.div`
  width: 100%;
`;

export const ProductTableItem = styled.div`
  height: 86px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  border-bottom: 1px solid #e2e8f0;

  ${({ first }) =>
    first &&
    css`
      justify-content: flex-start;
    `}

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(-10px);
    }
  }
`;

export const Currency = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #314158;

  ${({ bold }) =>
    bold &&
    css`
      font-weight: 600;
    `}
`;

export const ProductChangeQty = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #314158;

  gap: 8px;
`;

export const ChangeQtyButton = styled.button`
  background-color: transparent;
  border: 0;
  transition: all 300ms ease-in-out;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 50%;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CheckoutFooter = styled.footer`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${({ noBorder }) =>
    noBorder &&
    css`
      padding-top: 0;
      border-top: none;
    `}

  div.subtotal {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 16px;
    animation: ${enterFromBottom} 0.5s ease-in-out;
    p {
      color: #020618;
      margin-bottom: 0;
      font-family: "Open Sans";
      font-weight: 700;
      font-size: 20px;
      line-height: 100%;
      letter-spacing: 0%;
      vertical-align: middle;
    }
  }
`;

export const CouponContainer = styled.div`
  border-top: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 16px;
  padding: 16px 0;
  width: 100%;
  animation: ${enterFromBottom} 0.5s ease-in-out;

  p {
    margin-bottom: 0px;
    font-weight: 600;
    font-size: 16px;
    color: #314158;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: "Inter", sans-serif;
    line-height: 100%;
    letter-spacing: 0%;
  }

  & > div {
    display: flex;
    gap: 8px;
    margin-top: 8px;
  }
`;

export const CouponInput = styled(Input)`
  border-radius: 8px;
  height: 36px;
`;

export const CouponButton = styled(Button)`
  height: 36px;
  padding: 0;
  width: 50px;
  border-radius: 8px;
  font-size: 25px;
  display: flex;
  align-items: center;
  justify-content: center;

  &,
  &:hover,
  &:focus {
    color: #fff;
    background: #002244;
    border-color: #002244;
  }

  &:disabled {
    background: rgba(0, 34, 68, 0.37);

    &:hover,
    &:focus {
      background: rgba(0, 34, 68, 0.37);
    }
  }
`;

export const Coupon = styled.div`
  padding: 0px 0px 0px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  height: 36px;

  div {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  p {
    font-weight: 500;
    font-size: 14px;
    color: #314158;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: "Inter", sans-serif;
    line-height: 100%;
    letter-spacing: 0%;
    margin-bottom: 0;
  }

  button {
    border: 0;
    background-color: transparent;
    height: 100%;
    width: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: 300ms ease;
    font-family: "Inter", sans-serif;
    font-size: 18px;

    color: rgb(172, 32, 32) !important;

    &:hover {
      color: #000;
    }
  }

  justify-content: space-between;
  align-items: center;
`;

export const Modal = styled(M)`
  .ant-modal-content {
    border-radius: 8px !important;
  }
  .ant-modal-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 498px !important;
    padding: 24px !important;
  }
`;

export const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  margin-top: 8px;
  margin-bottom: 24px;

  ${({ buttons }) =>
    buttons &&
    css`
      margin: 0;
    `}
`;

export const ModalText = styled.p`
  text-align: center;
  margin-bottom: 0;
  line-height: 100%;
  letter-spacing: 0%;

  ${({ type }) => {
    switch (type) {
      default:
      case "sub":
        return css`
          font-family: "Inter";
          font-weight: "400";
          font-size: 14px;
          line-height: 120%;
          color: #314158;
          width: 410px;
        `;
      case "title":
        return css`
          font-family: "Open Sans";
          font-weight: 700;
          font-size: 20px;
          color: #020618;
        `;
    }
  }}
`;

export const ModalButton = styled(CheckoutButton)`
  line-height: 150%;
  box-shadow: 0px 1px 2px 0px #19191c0a;
  height: 35px;
  width: 100%;

  ${({ cancel }) =>
    cancel &&
    css`
      color: rgb(172, 32, 32);
      background-color: #fff;
      border-color: rgb(172, 32, 32);

      &:hover,
      &:focus {
        border-color: rgb(172, 32, 32) !important;
        background-color: rgb(172, 32, 32) !important;
        color: #fff;
      }
    `}
`;

export const AreaTitleBooth = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
`;

export const ContainerBooth = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  flex-direction: column;
  gap: 10px;
  max-height: 100px;
  overflow-y: auto;

  /* Prevent scrollbar from cutting rounded corners */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 16px;
  }

  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 16px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #cbd5e0;
  }
`;

export const AreaBooth = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  `
